var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0275B6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.23 12h2.202V9.935H9.23zM12.533 12h2.202V9.935h-2.202zM15.561 12h2.202V9.935h-2.202zM6.202 15.097h2.202v-2.065H6.202zM9.23 15.097h2.202v-2.065H9.23zM12.533 15.097h2.202v-2.065h-2.202zM15.561 15.097h2.202v-2.065h-2.202zM6.202 17.935h2.202v-2.064H6.202zM9.23 17.935h2.202v-2.064H9.23zM12.533 17.935h2.202v-2.064h-2.202z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.064 19h13.837V9H5.064v10zm2.13-12h1.063V5H7.193v2zm8.514 0h1.064V5h-1.064v2zm2.129-1V4.5c0-.275-.239-.5-.532-.5h-2.13c-.293 0-.531.225-.531.5V6H9.322V4.5c0-.275-.239-.5-.532-.5H6.66c-.293 0-.531.225-.531.5V6H4v14h15.966V6h-2.13z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.da0bc775e33584ca0f5d18503f89adf0.svg";
export { ForwardRef as ReactComponent };